module.exports = __webpack_public_path__ + "static/media/sketch4.d529d07d.jpg";